/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  divider: {
    flex: 1
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.mode === 'light' ? Palette.FractalUI.light.steel[2] : Palette.FractalUI.dark.steel[2],
    borderRadius: Tokens.spacing['$sp-1'],
    padding: Tokens.spacing['$sp-2'],
    color: theme.palette.text.primary,
    
  },
  iconAlignment: {
    marginRight: Tokens.spacing['$sp-4']
  },
  fontWeightBold: {
    fontWeight: 500
  },
  styler: {
    marginBottom: Tokens.spacing['$sp-7-5']
  }
}));
